import { createAction } from "@reduxjs/toolkit"
import { EditType } from "@store/reducers/init/types"


//activeComboChipIndex
export const changeActiveComboChipIndex = createAction<number>("INIT_CHANGE_ACTIVE_COMBO_CHIP_INDEX")
//isComboCustomStyle
export const changeIsComboCustomStyle = createAction<boolean>("INIT_CHANGE_IS_COMBO_CUSTOM_STYLE")
//isRow
export const changeIsRow = createAction<boolean>("INIT_CHANGE_IS_ROW")

export const changeImageFilters = createAction<{ name: string; filters: string[] }>("changeImageFilters")
export const changeEditType = createAction<EditType>("INIT_CHANGE__EDIT_TYPE")

//FormatSettings
export const changeTemplateProducts = createAction<any>("INIT_changeTemplateProducts")

//BarcodeSettings
export const changeBarCodeSettings = createAction<any>("INIT_CHANGE_BARCODE_SETTINGS")

//ActivePanel
export const changeActivePanel = createAction<string>("INIT_CHANGE_ACTIVE_PANEL")

//ActivePanel
export const changeFirstLoad = createAction("INIT_CHANGE_FIRST_LOAD")

//ImageUpload
export const changeImageUpload = createAction("INIT_CHANGE_IMAGE_UPLOAD")

//BadgeName
export const changeBadgeName = createAction("INIT_CHANGE_BADGE_NAME")

//Loading
export const changeIsLoading = createAction<boolean>("INIT_CHANGE_IS_LOADING")

//Paint Options
export const changePaintOptions = createAction("INIT_CHANGE_PAINT_OPTIONS")

export const changeDataFields = createAction<any>("INIT_CHANGE_DATA_FIELDS")
export const changeTags = createAction<any>("INIT_CHANGE_TAGS")
export const changeNewDesignOpen = createAction<any>("INIT_CHANGE_NEW_DESIGN_OPEN")

export const openBoothModal = createAction<any>("OPEN_BOOTH_MODAL")
export const openBoothSettingsModal = createAction<any>("OPEN_BOOTH_SETTINGS_MODAL")
export const saveAssignedTktIds = createAction<any>("SAVE_ASSIGNED_TICKET_IDS")
export const saveUnAssignedTktIds = createAction<any>("SAVE_UNASSIGNED_TICKET_IDS")
export const saveDeletedBoothIds = createAction<any>("SAVE_DELETED_BOOTH_IDS")
export const floormapHoverObject = createAction<any>("FLOOR_MAP_HOVER_OBJECT")
export const changeIsImporting = createAction<boolean>("CHANGE_IS_IMPORTING")

export const changeUserPermisison = createAction<string[]>("CHANGE_USER_PERMISSIONS")
